import { render, staticRenderFns } from "./Deliverable.vue?vue&type=template&id=663a87f8"
import script from "./Deliverable.vue?vue&type=script&lang=js"
export * from "./Deliverable.vue?vue&type=script&lang=js"
import style0 from "./Deliverable.vue?vue&type=style&index=0&id=663a87f8&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports